import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
const loader = new GLTFLoader();
let texture_loader = new THREE.TextureLoader();
import { ControlFunction } from "./controlFunction";
const pngCodeWall1b = texture_loader.load("./office/textures/codeWall1b.jpg");
import { progressbar, modelsLoaded } from "./progressbar";

const loadCodeWall1b = () => {
  const promiseCodeWall1b = new Promise((resolve, reject) => {
    const geometryCodeWall1b = new THREE.PlaneGeometry(1, 1);
    const materialCodeWall1b = new THREE.MeshBasicMaterial({
      map: pngCodeWall1b,
      transparent: true,
      toneMapped: false
    });
    const codeWall1b = new THREE.Mesh(geometryCodeWall1b, materialCodeWall1b);

    codeWall1b.scale.x = 1;
    codeWall1b.scale.y = 0.68;

    codeWall1b.position.set(
      -0.26639869672518846, 2.8115769276309006, 2.9581359829386775
    );

    scene.add(codeWall1b);
   // ControlFunction(codeWall1b);

    resolve(codeWall1b);
    progressbar();
  });

  return promiseCodeWall1b;
};

export { loadCodeWall1b };
